// Backend regex enforced on app-data + storage keys.
// See G24/G46 in catalog/known-gotchas.md. Case-sensitive (no /i flag);
// camelCase, leading underscore, leading dot, or anything > 128 chars
// fails the backend with HTTP 400 — validate client-side so the
// SdkValidationError surfaces at the call site instead.
export const KEY_RE = /^[a-z0-9][a-z0-9_.-]{0,127}$/;
